<div class="d-flex">
    <div class="dp-hidden position-absolute">
        <div class="input-group">
            <input
                name="datepicker"
                class="form-control"
                ngbDatepicker
                #datepicker="ngbDatepicker"
                [autoClose]="autoClose()"
                (dateSelect)="
                    range()
                        ? onDateRangeSelection($event)
                        : onDateSelection($event)
                "
                (closed)="onClosed()"
                [displayMonths]="range() ? 2 : 1"
                [dayTemplate]="t"
                [startDate]="startDate"
                [minDate]="minimumDate"
                [maxDate]="maximumDate"
                [outsideDays]="outsideDays()"
                outsideDays="hidden"
                tabindex="-1"
                weekdays="short"
            />
            <ng-template #t let-date let-focused="focused">
                <span
                    class="custom-day"
                    [class.focused]="focused"
                    [class.range]="
                        (range() && isRange(date)) ||
                        (!range() && isSelected(date))
                    "
                    [class.faded]="
                        range() && (isHovered(date) || isInside(date))
                    "
                    (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null"
                >
                    {{ date.day }}
                </span>
            </ng-template>
        </div>
    </div>
    <div
        class="input-group pointer"
        (click)="datepicker.toggle()"
        (keypress)="datepicker.toggle()"
        (mouseenter)="isInputHovered = true"
        (mouseleave)="isInputHovered = false"
        tabindex="0"
    >
        <input
            class="form-control pointer"
            [ngClass]="{
                'be-none': hasValue || range(),
                hovered: isInputHovered,
            }"
            readonly
            value="{{ fromDateText }}"
        />
        @if (range()) {
            <span
                class="input-group-text white pointer be-none"
                [ngClass]="{
                    hovered: isInputHovered,
                }"
            >
                <i class="fa-light fa-arrow-right font-xs"></i>
            </span>
            <input
                class="form-control bs-none pointer"
                [ngClass]="{ 'be-none': hasValue, hovered: isInputHovered }"
                readonly
                value="{{ toDateText }}"
            />
        }
        @if (hasValue) {
            <span
                class="input-group-text white pointer"
                [ngClass]="{
                    hovered: isInputHovered,
                }"
                (click)="clear($event)"
                (keypress)="clear($event)"
                tabindex="1"
                (mouseenter)="isClearHovered = true"
                (mouseleave)="isClearHovered = false"
            >
                <i
                    class="fa-circle-xmark"
                    [ngClass]="isClearHovered ? 'fa-solid' : 'fa-light'"
                ></i>
            </span>
        }
        <span class="input-group-text pointer">
            <i class="fa-light fa-calendar-pen"></i>
        </span>
    </div>
</div>
